class StullerRequire {
    constructor() {
        this.requireLoaded = false;
        this.requireLoading = false;
        this.ready = (callback) => {
            if (this.requireLoaded) {
                callback();
                return;
            }
            $("body").on("stuller-require-loaded", callback);
        };
        this.load = (scriptVersion, context) => {
            if (this.requireLoading || this.requireLoaded)
                return;
            this.requireLoading = true;
            if (scriptVersion.toLowerCase() == 'test') {
                scriptVersion = new Date().getTime().toString();
            }
            window["globalScriptVersion"] = scriptVersion;
            $.ajax({
                dataType: "script",
                cache: true,
                url: '/scripts/build/require.js?v=' + scriptVersion
            }).done(() => {
                require(["/scripts/build/requirejs_config.js?v=" + scriptVersion], () => {
                    require(["UI/Context"], ctx => {
                        ctx["default"] = new ctx.Context(context);
                        this.requireLoaded = true;
                        this.requireLoading = false;
                        $("body").trigger("stuller-require-loaded");
                    });
                });
            });
        };
    }
}
var stullerRequire = new StullerRequire();
var requireReady = stullerRequire.ready;
//# sourceMappingURL=StullerRequire.js.map